//Importaciones
import React, { useRef } from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainAppContext from '../../../../MainAppContext';
import { useSelector } from 'react-redux';
import AuthVerify from '../../../../components/Templates/Site/AuthVerify';
import CalendarFilter from '../../../../components/Products/sKPI/Board/CalendarFilter';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useGetBoardStructureComponentsData2, useGetBoardStructureGeneric, useGetBoardVariableDataSerieValues } from '../useOfBoard';
import { ActionButton, Pivot, PivotItem } from '@fluentui/react';
import { Card, Col, Row } from 'react-bootstrap';
import BoardComponentContent from '../ComponentManager/BoardComponentContent';
import BoardComponentInfoContent from '../ComponentManager/BoardComponentInfoContent';
import { enum__BOARD_TEMPLATE_TYPE, enum__ComponentType } from '../../../../common/Dictionaries';
import { __onGetDataGridHtmlContainer } from '../../../../common/CommonFuctions';
import MessageBox from '../../../../components/Common/Message/MessageBox';
import './reportstyle.css'
import { useGetUserPropsKpi } from '../../../../hooks/services/sPrivilege/useOfPrivilege';
import Loading from '../../../../components/Templates/Site/Loading';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../common/Helpers';
import AuxContractInfo from './AuxContractInfo';
import { exportToPPT } from '../../../../utils/exportTo';
import { useGetContractByElementId } from '../../../../hooks/services/sKPI/useOfBoard';
import moment from 'moment';
import { useGetReportClientLogo } from '../../../../hooks/services/_Transversal/useOfTransversal';


function Report(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);
    const ResponsiveGridLayout = WidthProvider(Responsive);
    const BoardTypeId = enum__BOARD_TEMPLATE_TYPE.MULTI ;
    const inputParam_HideHeader = false;
    const hasPageElementId = true;
    
    const queryStringElementId = props.match.params.elementId !== null && props.match.params.elementId !== undefined && props.match.params.elementId !== "" ? props.match.params.elementId : null;

    const { _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardComponentInfoRecursiveFilled: boardComponentInfoRecursiveFilled } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardContractFilterOfComponents: boardContractFilterOfComponents } = useSelector((state) => state.boardViewComponentsScope);

    const [structureFireGetData, setStructureFireGetData] = useState(true);

    const [boardStructureSpecific, setBoardStructureSpecific] = useState(null)
    const [boardVariableDataserieValues, setBoardVariableDataserieValues] = useState(null)
    const pivotRef = useRef(null);

    const [messageConfig, setMessageConfig] = useState({ message : null, messageType : "error", showMessage : true });
    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(BoardTypeId, !isNullUndefinedOrEmpty(boardStructureSpecific) ? (boardStructureSpecific.length > 0 ? boardStructureSpecific[0].id : 0) : 0, queryStringElementId, currentAuth.token.userName, userPropsKpi, setUserPropsKpi)

    const [clientLogo, setClientLogo] = useState(undefined)
    useGetReportClientLogo(clientLogo, setClientLogo)

    const layoutConfiguration = {
        measureBeforeMount: true,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        cols: { lg: 36, md: 30, sm: 18, xs: 12, xxs: 6 },
        rowHeight: 50,
        draggableHandle: ".dragHandle",
        margin: [10, 10, 10, 10]
    }

    const [contract, setContract] = useState(null)
    useGetContractByElementId(queryStringElementId, contract, setContract)

    useGetBoardStructureGeneric(BoardTypeId, queryStringElementId, boardStructureSpecific, setBoardStructureSpecific);
    useGetBoardStructureComponentsData2(boardContractFilterOfComponents, hasPageElementId, queryStringElementId, boardStructureSpecific, contextSite.kpiModule.boardCalendarFilterConfig, boardComponentInfoRecursiveFilled, true);
    useGetBoardVariableDataSerieValues(boardStructureSpecific, boardStructureSpecific !== null && boardStructureSpecific.length > 0 ? boardStructureSpecific[0].id : null, queryStringElementId, null, contextSite.kpiModule.boardCalendarFilterConfig, boardComponentInfoRecursiveFilled, setBoardVariableDataserieValues)

    const generateContainerInfo = (boardStructure, container) => {
        return  <>
                    {
                        container.l_components_info.map((componentInfo, index) => {
                            return  <div key={index} className='h-100'
                            data-container-id={!isNullUndefined(componentInfo) ? componentInfo.containerId : ''}
                            data-component-id={!isNullUndefined(componentInfo) ? componentInfo.id : ''}>
                                        <BoardComponentInfoContent
                                            inputParam_HasPageElementId={hasPageElementId}
                                            inputParam_ElementId={queryStringElementId}
                                            inputParam_ContainerComponent={componentInfo}
                                            inputParam_BoardType={BoardTypeId}
                                            inputParam_BoardStructure={boardStructureSpecific}
                                            inputParam_ReportHeaderMode={true}
                                            //[#solucion pmz#]
                                            inputParam_BoardId={boardStructureSpecific !== null && boardStructureSpecific.length > 0 ? boardStructureSpecific[0].id : null}
                                            //[#NEW#]
                                            setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                            inputParam_ContainerComponentIndex={index}
                                            inputParam_UserPropsKpi={userPropsKpi}
                                        />
                                    </div>
                        })
                    }
                </>
    };

    const generateContainerDs = (boardStructure, container) => {

        const lListTypesContainerComponents = container.l_components.filter(x => x.componentTypeId <= enum__ComponentType.COLOR);
        const lOtherTypesContainerComponents = container.l_components.filter(x => x.componentTypeId > enum__ComponentType.COLOR);

        const containerHasListComponent = lListTypesContainerComponents.length > 0;

        if (containerHasListComponent) {
            
            return  <><Card className="h-100 w-100 p-0 m-0">
                        {
                            !inputParam_HideHeader &&
                            <Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                            { container.title ?? t('data-lang-boxname-dataserie')}
                            </Card.Body>
                        }
                        <Card.Body className='px-1 py-0 h-100' style={{ overflowY: "auto", overflowX: "auto" }}>
                        {
                            lListTypesContainerComponents.map((component, index) => {
                                return  <div key={index}>
                                            <BoardComponentContent
                                                inputParam_ElementId={queryStringElementId}
                                                inputParam_ContainerComponent={component}
                                                inputParam_ContainerComponentIndex={index}
                                                inputParam_BoardId={boardStructureSpecific[0].id}
                                                
                                                //[#NEW#]
                                                setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                            />
                                        </div>
                            })
                        }
                        </Card.Body>
                    </Card>
                        {
                            lOtherTypesContainerComponents.map((component, index) => {
                                return  <div key={index}>
                                            <BoardComponentContent
                                                inputParam_ElementId={queryStringElementId}
                                                inputParam_ContainerComponent={component}
                                                inputParam_ContainerComponentIndex={index}
                                                inputParam_BoardId={boardStructureSpecific[0].id}

                                                //[#NEW#]
                                                setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                            />
                                        </div>
                            })
                        }
                    </>
        }
        else {
            return  <>
                        {
                            container.l_components.map((component, index) => {
                                return  <div key={index}>
                                            <BoardComponentContent
                                                inputParam_ElementId={queryStringElementId}
                                                inputParam_ContainerComponent={component}
                                                inputParam_ContainerComponentIndex={index}
                                                inputParam_BoardId={boardStructureSpecific[0].id}

                                                //[#NEW#]
                                                setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                            />
                                        </div>
                            })
                        }
                    </>
        }
    };

    //Render de componente.
    return (<>
                <AuthVerify currentToken={currentAuth} />
                {
                    (boardStructureSpecific && boardStructureSpecific.length > 0 && boardStructureSpecific.length > 0 && boardVariableDataserieValues) &&
                    <>
                        {
                            userPropsKpi && (userPropsKpi.hasAccess === true || userPropsKpi.onlyObserver === true) &&
                            <>
                                <CalendarFilter inputParam_BoardId={boardStructureSpecific[0].id} inputParam_ForceShowCalendar={false} />
                                <AuxContractInfo inputParam_HideHeader={false} inputParam_ElementId={queryStringElementId} />
                                {
                                    boardComponentInfoRecursiveValues &&
                                    boardStructureSpecific.map((boardStructure, indexBoardStructure) => {
                                        return <Card className='mt-2' key={indexBoardStructure}>
                                                    {
                                                        boardStructure.l_structure.length === 1 &&
                                                        <ResponsiveGridLayout
                                                            measureBeforeMount={layoutConfiguration.measureBeforeMount}
                                                            breakpoints={layoutConfiguration.breakpoints}
                                                            //cols={layoutConfiguration.cols}
                                                            rowHeight={layoutConfiguration.rowHeight}
                                                            cols={ { lg: 12, xs: 12 } }
                                                            isDraggable={false}
                                                            isDroppable={false}
                                                            isResizable={false}
                                                            //onLayoutChange={onLayoutChange}
                                                            //onResize={onResize}
                                                            //draggableHandle={ boardMoveZones ? ".dragHandle" : '.no-drag'}
                                                            margin={[10, 10, 10, 10]}
                                                        >
                                                            {
                                                                boardStructure.l_structure[0].l_container.map((container, index) => (
                                                                    <div key={index} data-grid={ __onGetDataGridHtmlContainer(container) }  className="gridItem" >
                                                                        {generateContainerInfo(boardStructure, container)}
                                                                        { container.l_components.length > 0 && boardVariableDataserieValues && generateContainerDs(boardStructure, container)}
                                                                    </div>
                                                                ))
                                                            }
                                                        </ResponsiveGridLayout>
                                                    }
                                                    {
                                                        boardStructure.l_structure.length > 1 &&
                                                        <>
                                                                <Row>
                                                                    <Col></Col>
                                                                    <Col className='col-auto me-auto'>
                                                                        {
                                                                            clientLogo !== undefined &&
                                                                            <ActionButton onClick={() => exportToPPT(pivotRef.current, '.ms-Pivot-link', {periodText: t('data-lang-lbl-field-serieTime'), prefixTitle: t('data-lang-exporttitle-presentation'), sufixTitle: t("data-lang-exporttitle-report"), contractName: contract.name, contractCode: contract.contractCode, eeccName: contract.legalEntitySupplierName, areaName: contract.legalEntityBuyerName, adnName: contract.adminUsername, period: moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('DD/MM/yyyy')}, clientLogo)} className="pb-2 pe-3" iconProps={{ iconName: 'CloudDownload' }} >
                                                                                {t('data-lang-btn-exportppt')}
                                                                            </ActionButton>
                                                                        }
                                                                    </Col>
                                                                </Row>                                                         
                                                            <div className='pivotToExport' ref={pivotRef}>
                                                                <Pivot className='pivot-report bg-white border mx-2'>
                                                                    {
                                                                        boardStructure.l_structure.map((structure, index) => {
                                                                            return <PivotItem key={index} headerText={structure.htmlTitle }>
                                                                                <ResponsiveGridLayout
                                                                                    key={index}
                                                                                    measureBeforeMount={layoutConfiguration.measureBeforeMount}
                                                                                    breakpoints={layoutConfiguration.breakpoints}
                                                                                    //cols={layoutConfiguration.cols}
                                                                                    rowHeight={layoutConfiguration.rowHeight}
                                                                                    cols={ { lg: 12, xs: 12 } }
                                                                                    isDraggable={false}
                                                                                    isDroppable={false}
                                                                                    isResizable={false}
                                                                                    //onLayoutChange={onLayoutChange}
                                                                                    //onResize={onResize}
                                                                                    //draggableHandle={ boardMoveZones ? ".dragHandle" : '.no-drag'}
                                                                                    margin={[10, 10, 10, 10]}
                                                                                >
                                                                                    {
                                                                                        structure.l_container.map((container, index) => (
                                                                                            <div key={index} data-container-id={container.id} data-grid={ __onGetDataGridHtmlContainer(container) } className="gridItem" >
                                                                                                {generateContainerInfo(boardStructure, container)}
                                                                                                { container.l_components.length > 0 && boardVariableDataserieValues && generateContainerDs(boardStructure, container)}
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                </ResponsiveGridLayout>
                                                                            </PivotItem>
                                                                        })
                                                                    }
                                                                </Pivot>
                                                            </div>
                                                        </>
                                                    }
                                                </Card>
                                    })
                                }
                            </>
                        }
                        {
                            userPropsKpi && (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false) &&
                            <div className="pt-5 mt-4">
                                <MessageBox  
                                    inputParam_Message={ (userPropsKpi.hasAccess === false ? t('data-lang-msg-accessdenied') : "") }
                                    inputParam_Display={ messageConfig.showMessage }
                                    inputParam_MessageType={ messageConfig.messageType }
                                    inputParam_SetterMessage={ setMessageConfig }
                                />
                            </div>
                        } 
                    </>
                }
                {
                    !(boardStructureSpecific && boardStructureSpecific.length > 0 && boardStructureSpecific.length > 0 && boardVariableDataserieValues) &&
                    <Loading inputParam_ShowLoading={true} />
                }
            </>
    );
}

export default Report;